module.exports = __webpack_public_path__ + "img/passlogo.5ecad6c8.png";